import * as withUserProfileActions from '../actions/user-profiles';
import { UserProfile } from '../models/user-profile';

export interface State {
  userProfiles: UserProfile[];
  loading: boolean;
}

export const INITIAL_STATE: State = {
  userProfiles: undefined,
  loading: false,
}

export function reducer(state: State = INITIAL_STATE, action: withUserProfileActions.Actions) {

  switch (action.type) {
    case withUserProfileActions.LOAD:
      {
        return {
          ...state,
          loading: true
        };
      }
    case withUserProfileActions.LOAD_COMPLETE:
      {
        return {
          ...state,
          loading: false,
          userProfiles: action.payload
        };
      }
    default:
      {
        return state;
      }
  }
}
